import { Card, Col, Divider, Row, Typography } from "antd";
import React, { useState } from "react";
import AperturaDeCajaForm from "./AperturaDeCajaForm";
import AperturaDeCajaList from "./AperturaDeCajaList";
import "./AperturaDeCajaStyles.css";

const { Title } = Typography;

const AperturaDeCajaManagement = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [selectedApertura, setSelectedApertura] = useState(null);
    const isMobile = window.innerWidth < 768;

    // Esta función se ejecutará cuando se agregue una nueva apertura
    const handleAperturaAdded = () => {
        // Incrementar el key para forzar la actualización de la lista
        setRefreshKey((prevKey) => prevKey + 1);
    };

    // Esta función se ejecutará cuando se edite una apertura
    const handleAperturaEdited = (apertura) => {
        setSelectedApertura(apertura);
    };

    // Esta función se ejecutará cuando se actualice una apertura
    const handleAperturaUpdated = () => {
        // Limpiar la apertura seleccionada e incrementar el key para actualizar la lista
        setSelectedApertura(null);
        setRefreshKey((prevKey) => prevKey + 1);
    };

    return (
        <div className="apertura-caja-management-container">
            <Title level={2}>{isMobile ? "Aperturas de Caja" : "Gestión de Aperturas de Caja"}</Title>
            <Divider />

            <Row gutter={[24, 24]}>
                <Col xs={24} lg={12}>
                    <Card>
                        <AperturaDeCajaForm
                            onAperturaAdded={handleAperturaAdded}
                            onAperturaUpdated={handleAperturaUpdated}
                            aperturaToEdit={selectedApertura}
                        />
                    </Card>
                </Col>

                <Col xs={24} lg={12}>
                    <AperturaDeCajaList
                        refreshTrigger={refreshKey}
                        onEditApertura={handleAperturaEdited}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default AperturaDeCajaManagement; 